import { ComponentTemplateInfo } from '../info';

// tslint:disable:ban-types

/**
 * Class decorator.
 * 
 * Mark this class as a redux component.
 */
export function component(ctor: Function): any {
    ComponentTemplateInfo.getOrInitInfo(ctor);
}


// WEBPACK FOOTER //
// ./node_modules/ts-nameof-loader/main.js!./src/decorators/component.ts